import React, { useContext } from "react";
import { Route, Navigate } from "react-router-dom";
import AuthLayout from "../layouts/auth/index";
import { PayLoadCtx, RoleCtx } from "../lib/context";
const PatientRoute = ({ children }) => {
    const { payload } = useContext(PayLoadCtx);
    const { role } = useContext(RoleCtx);
    return payload && role === "P" ? <AuthLayout role="Patient">{children}</AuthLayout> : <Navigate to="/" />;
};

export default PatientRoute;
